import React from 'react';
import Toast from "../Toast";
import CmsContentList from '../data/CmsContentList';
import { useGlobalToastsContext } from 'context/ToastProvider.js';
import CmsContentRenderedInline from 'components/data/CmsContentRenderedInline';

const cms = {
	pass: 'miscText.autoload-confirmation-pass',
};

const PassAutoloadEnabled = ({ pass }) => {
	const { removeToast } = useGlobalToastsContext();
	return (
		<CmsContentList list={Object.values(cms)}>{({ cmsContent }) => (
			<Toast
				type="success"
				title={<>
					<CmsContentRenderedInline
						contentKey={cms.pass}
						fallbackValue={`${pass} set to autoload.`}
						variables={{ pass }}
					/>
				</>}
				onClosed={removeToast}
			/>
		)}
		</CmsContentList>
	);
};

export default PassAutoloadEnabled;
